import { useState, useEffect } from 'react';
import * as THREE from 'three';

import { Flavor } from '../../../types';
import useScrollStore from '../../../store/useScrollStore';

import { label } from './materials';
import { cleanTexture } from './utils';

const path = "/static/images/labels/top";

const setMap = (texture: THREE.Texture) => {
  label.top.outer.map = texture;
  label.top.inner.map = texture;
}

const useTopTexture = (flavor: Flavor) => {
  /**
   * Load texture
   */
  const [textures, setTextures] = useState<THREE.Texture[]>([]);

  useEffect(() => {
    const loader = new THREE.TextureLoader();

    const promises = [
      loader.loadAsync(`${path}/apple.png`),
      loader.loadAsync(`${path}/blackberry.png`),
      loader.loadAsync(`${path}/blueberry.png`),
      loader.loadAsync(`${path}/elderflower.png`),
      loader.loadAsync(`${path}/mango.png`),
      loader.loadAsync(`${path}/pear.png`),
      loader.loadAsync(`${path}/redrhubarb.png`),
      loader.loadAsync(`${path}/watermelon.png`)
    ];

    Promise.all(promises).then(textures => {
      textures.forEach(texture => cleanTexture(texture));
      setTextures(textures);
    });
  }, []);

  /**
   * Hacks to fix the white texture issue
   */
  const [unsub, setUnsub] = useState(false);

  useEffect(() => {
    if (!unsub) return useScrollStore.subscribe(state => {
      if (-state.position >= window.innerHeight / 2) {
        label.top.outer.transparent = true;
        setUnsub(true);
      }
    });
  }, [unsub]);

  /**
   * Change cider color and label
   */
  useEffect(() => {
    if (textures.length === 8) {
      switch (flavor) {
        case "apple": setMap(textures[0]); break;
        case "blackberry": setMap(textures[1]); break;
        case "blueberry": setMap(textures[2]); break;
        case "elderflower": setMap(textures[3]); break;
        case "mango": setMap(textures[4]); break;
        case "pear": setMap(textures[5]); break;
        case "redrhubarb": setMap(textures[6]); break;
        case "watermelon": setMap(textures[7]); break;
      }
    }
  }, [flavor, textures.length]);
}

export default useTopTexture;